import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';
import * as api from '../../Utils/ajax';
import { GET_MFA_STATUS, LOGIN_USER, MULI_FACTOR_SETUP } from '../Actions/actions';

const setToStorage = (fieldName, value) => {
    // localStorage.removeItem("bot_id");
    // localStorage.removeItem("bot_name");
    localStorage.setItem(fieldName, value);
};

const fetchData = async (url) =>
    await api.getMFAStatus(url);

const loginpost = async (url, payload) =>
    await api.loginpost(url, payload);

// const baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'http://127.0.0.1:5001';
const baseUrl = '/api/v1';

export function* getMultifactorStatus(params) {
    const payload = params.payload;
    const cb = params.cb;
    const ebplatform = "botforge";

    const url = baseUrl + `/adminusers/multifactor/status?ebPlatform=${ebplatform}&emailId=` + encodeURIComponent(payload.userName);

    try {
        const response = yield call(fetchData, url );
        if(cb)
            cb(response.data);
    } catch(error) {
        console.log(error);
    }
}

export function* loginUser(params) {
    const payload = params.payload;
    const cb = params.cb;
    const errorFun = params.errorFun;
    const url = baseUrl + '/adminusers/login';
    payload.ebplatform = "botforge";

    try {
        // yield call(foo, url, payload);
        const response = yield call(loginpost, url, payload);
        if(response && response.error && response.error.code && response.error.code === 1004 && response.error.message) {
            errorFun(response.error.message);
            return;
        }
        // if(!response?.success) {
        //     throw(response);
        // }
        if(response && response.error && response.error.error && response.error.error.error && response.error.error.error.message) {
            errorFun(response.error.error.error.message);
            return;
        }
        const data =response;
        setToStorage("id_token", data.id);
        setToStorage("user_id", data.user.id);
        setToStorage("user_data", JSON.stringify(data.user));
        if(cb) {
            cb(data);
        }
    } catch(err) {
        if(errorFun) {
            let errorMsg = err?.error?.message?.error?.error?.message;
            if(!errorMsg) {
                errorMsg = 'Something went wrong';
            }
            errorFun(errorMsg);
        }
        // console.log(err);
    }
}

export function* doMultiFactorSetup(params) {
    const payload = params.payload;
    const cb = params.cb;
    const url = baseUrl + '/adminusers/multifactor/setup';

    try {
        // yield call(foo, url, payload);
        const response = yield call(loginpost, url, payload);
        if(response && response.error && response.error.error && response.error.error.error) {
            const err = response.error.error.error;
            if(err.statusCode && err.statusCode === 401) {
                params.errorFun(err.message);
                return;
            } else if(err.statusCode && err.statusCode === 400) {
                params.errorFun(err.message);
                if(cb)
                    cb('email-auth', response.data);
                return;
            } else {
                params.errorFun(response.error);
                return;
            }
        }
        const data = response.data;
        if(cb)
            cb('email-auth', data);
    } catch(error) {
        console.log(error);
    }
}

export function* loginWatcher() {
    yield takeLatest(GET_MFA_STATUS, getMultifactorStatus);
    yield takeLatest(LOGIN_USER, loginUser);
    yield takeLatest(MULI_FACTOR_SETUP, doMultiFactorSetup);
}